/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled                        from 'styled-components';
import { rgba }                      from 'polished';
import { Colours, Borders, Spacing } from '../../../styles/variables';
import { Media }                     from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledSemiOpaqueBlock = styled.div`
  background: ${rgba(Colours.White, 0.3)};
  border-radius: ${Borders.Radius};
  padding: ${Spacing.Small};
  display: inline-block;
  ${Media.Tablet`
    padding: ${Spacing.Medium};
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledSemiOpaqueBlock/index.js